{
  "identity": {
    "title": "Identità"
  },
  "status": {
    "title": "Stato"
  },
  "lastUpdate": {
    "title": "Ultimo aggiornamento"
  },
  "profile": {
    "title": "Profilo"
  },
  "group": {
    "title": "Gruppo"
  },
  "state": {
    "title": "Stato"
  },
  "name": {
    "title": "Nome"
  },
  "operations": {
    "title": "Operazioni"
  },
  "connectionParameters": {
    "title": "Parametri di connessione"
  },
  "specificParameters": {
    "title": "Parametri specifici"
  },
  "roles": {
    "title": "Permessi"
  }
}
